<app-linkable
    typename="events"
    [displayValueProp]="displayValueProp"
    [linked]="linked"
    [unlinked]="unlinked"
    [orderByValueProperty]="true"
    [disabled]="disabled"
    (onOpenClicked)="openItem($event)"
    [hideActions]="hideActions"
    [hideFilter]="hideFilter"
    [allowAddNew]="allowAddNew"
    [allowEditItem]="allowEditItem"
    [allowBatchEdit]="allowBatchEdit"
    [allowOpenItem]="true"
>
</app-linkable>
